import { render, staticRenderFns } from "./ChoiceTypes.vue?vue&type=template&id=4a5546a4"
import script from "./ChoiceTypes.vue?vue&type=script&lang=ts"
export * from "./ChoiceTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
